import * as Yup from "yup";

export const technologyInitiativeSchema = Yup.object().shape({
  name: Yup.string().required("Initiative name is required"),
  institution_id: Yup.string().required("Institution is required"),
  session_id: Yup.string().required("Year is required"),
});
